"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types = require("./types");
exports.updateRequest = (extensionName) => ({
    extensionName, type: types.UPDATE_REQUEST,
});
exports.updateSuccess = (extensionName, data = {}) => ({
    extensionName, data, type: types.UPDATE_SUCCESS,
});
exports.updateFailure = (extensionName, errorMessage) => ({
    extensionName, errorMessage, type: types.UPDATE_FAILURE,
});
//# sourceMappingURL=actions.js.map